import type FilePickerViewState from '../store/schema/FilePickerViewState';
import { action } from 'satcheljs/lib/legacy';
import type { FilePickerViewType } from '../types/FilePickerViewSwitcher';
import type { FileProviderViewState } from 'owa-fileprovider-store';
import { getFileProviderInfo } from '../utils/fileProviderInfo';

export default action('changeFilePickerView')(function changeFilePickerView(
    view: FilePickerViewType,
    selectedFileProvider: FileProviderViewState,
    viewState: FilePickerViewState
) {
    const fileProviderInfo = getFileProviderInfo(selectedFileProvider.type);

    if (fileProviderInfo.supportedFilePickerViews.indexOf(view) !== -1) {
        // Change the view type only if it is supported by the selected file provider
        viewState.selectedView = view;
        viewState.supportedViews = fileProviderInfo.supportedFilePickerViews;
    }
});
